import { useCallback } from 'react'
import type { components } from 'src/types/kumap'
import { useHttpsCallable } from 'src/utils/firebase'

export type CreateKumapPointRequest = components['schemas']['CreateRequest']
export type KumapPointResponse = components['schemas']['PointResponse']

export type CreateKumapPointPayload = {
  clientId: string
  deviceId: string
  messageId: string
  content: string
  position: { lat: number; lng: number }
  request: CreateKumapPointRequest
}

export const useKumap = () => {
  const [call, isCalling, callError] = useHttpsCallable<CreateKumapPointPayload, KumapPointResponse>('createKumapPoint')

  const createKumapPoint = useCallback(
    async (payload: CreateKumapPointPayload) => {
      const res = await call(payload)
      return res?.data
    },
    [call],
  )

  return { createKumapPoint, isCalling, callError }
}
